import api from './client';

export type ReviewStatus = 'pending' | 'approved' | 'rejected';

export interface ProductReview {
  id: number;
  shopify_product_id: number;
  product_title: string | null;
  reviewer_name: string;
  reviewer_email: string;
  rating: number;
  title: string | null;
  body: string;
  photos: string[];
  status: ReviewStatus;
  is_verified_purchase: boolean;
  merchant_reply: string | null;
  merchant_reply_at: string | null;
  helpful_count: number;
  created_at: string | null;
}

export const reviewsApi = {
  list: (page = 1, status?: ReviewStatus) =>
    api.get<{ data: ProductReview[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/reviews?page=${page}${status ? `&status=${status}` : ''}`
    ),

  updateStatus: (id: number, status: 'approved' | 'rejected') =>
    api.patch<{ data: ProductReview }>(`/reviews/${id}/status`, { status }),

  reply: (id: number, reply: string) =>
    api.patch<{ data: ProductReview }>(`/reviews/${id}/reply`, { reply }),

  destroy: (id: number) => api.delete(`/reviews/${id}`),
};
